import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=0c22c1d7&scoped=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"
import style0 from "./Select.vue?vue&type=style&index=0&id=0c22c1d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c22c1d7",
  null
  
)

export default component.exports